module.exports = __webpack_public_path__ + "ae0163567d781cdae2cd274ec112135d.png";